import React from "react";
import { Link } from "react-router-dom";
import {
  Badge,
  Container,
  Dropdown,
  FormControl,
  Nav,
  Button,
} from "react-bootstrap";
import { AiFillDelete } from "react-icons/ai";
import { FaShoppingCart } from "react-icons/fa";
import { CartState } from "../context/Context";

export default function Navbar() {
  const {
    state: { cart },
    dispatch,
  } = CartState();
  return (
    <>
      <nav
        className="navbar navbar-expand-lg bg-body-tertiary sticky-top"
        style={{ backgroundColor: "white" }}
      >
        <div className="container-fluid">
          <Link
            className="navbar-brand"
            to="/"
            onClick={() => {
              window.scroll({
                top: 0,
                 behavior:"instant",
              });
            }}
          >
            <img
              src="./images/logo.png"
              alt="Shri Shyam Interiors"
              style={{ width: "11rem", mixBlendMode: "darken" }}
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  className="nav-link active "
                  aria-current="page"
                  to="/"
                  onClick={() => {
                    window.scroll({
                      top: 0,
                       behavior:"instant",
                    });
                  }}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link "
                  to="/about"
                  onClick={() => {
                    window.scroll({
                      top: 0,
                       behavior:"instant",
                    });
                  }}
                >
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link "
                  to="/cart"
                  onClick={() => {
                    window.scroll({
                      top: 0,
                       behavior:"instant",
                    });
                  }}
                >
                  Your Cart
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/product"
                  onClick={() => {
                    window.scrollTo({
                      top: 0,
                      behavior:"instant"
                    });
                  }}
                >
                  Products
                </Link>
              </li>
              <li>
                <Nav>
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <FaShoppingCart color="white" fontSize="20px" />
                      <Badge bg="success">{cart.length}</Badge>
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ minWidth: 200 }}>
                      {cart.length > 0 ? (
                        <>
                          {cart.map((prod) => {
                            return (
                              <span className="cartitem" key={prod.id}>
                                <img
                                  src={prod.image}
                                  className="cartItemImg"
                                  alt={prod.name}
                                />
                                <div className="cartItemDetail">
                                  <span>{prod.name}</span>
                                  <span>₹ {prod.price.split(".")[0]}</span>
                                </div>
                                <AiFillDelete
                                  fontSize="20px"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    dispatch({
                                      type: "REMOVE_TO_CART",
                                      payload: prod,
                                    })
                                  }
                                />
                              </span>
                            );
                          })}
                          <Link
                            to="/Cart"
                            onClick={() => {
                              window.scroll({
                                top: 0,
                                 behavior:"instant",
                              });
                            }}
                          >
                            <Button style={{ width: "95%", margin: "0 10px" }}>
                              Go To Cart
                            </Button>
                          </Link>
                        </>
                      ) : (
                        <span style={{ padding: 10 }}> Cart is empty!!</span>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </Nav>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
